import {Component} from '@angular/core';

@Component({
  selector: 'app-full-layout',
  template: `
      <app-navigation></app-navigation>
      <div class="page-content">
          <router-outlet></router-outlet>
      </div>
  `
})
export class FullContainerComponent {
}



// WEBPACK FOOTER //
// D:/Projects/bid/frontend/src/app/shared/layouts/full-container/full-container.component.ts